// FITIT prekės ženklo Fluent 2 tema — BrandVariants (16 žingsnių) sugeneruota IŠ JAU
// ESAMOS, apgalvotos Tailwind `primary` skalės (tailwind.config.js), ne sugalvota iš
// naujo. 10 iš 16 reikšmių yra TIKSLIAI tos pačios hex vertės (kryptis apversta —
// Tailwind: 50=šviesiausia→900=tamsiausia; Fluent: shade10=tamsiausia→shade160=šviesiausia),
// likę 6 (20,30,50,90,110,130) — HSL interpoliacija tarp gretimų inkarų (žr. plano failą).
//
// Fluent semantinės nuorodos (fiksuotos, neišvengiamos): colorBrandBackground=shade80,
// colorBrandBackgroundHover=shade70, colorBrandBackgroundPressed=shade40 — atitinka
// TAILWIND_PRIMARY[500]/[600]/[800], kurie jau ir buvo naudojami tam pačiam tikslui
// (žr. admin/components/ui.jsx .btn-primary/.btn-primary:hover).
import { createLightTheme, createDarkTheme } from '@fluentui/react-components';

export const fititBrandRamp = {
  10: '#02261f',
  20: '#023128',
  30: '#033c30',
  40: '#034739',
  50: '#045847',
  60: '#056954',
  70: '#078a6e',
  80: '#09aa89',
  90: '#1bb79a',
  100: '#33bfa7',
  110: '#49cab4',
  120: '#66cfbd',
  130: '#7fd7c8',
  140: '#99dfd3',
  150: '#ccefe9',
  160: '#e6f7f4',
};

// "Gold" — Fluent tema priima TIK VIENĄ keičiamą BrandVariants rampą (žr. plano failą),
// tad antra prekės ženklo spalva (naudota akcentams/gold badge'ams) lieka kaip paprastas
// hex objektas, naudojamas TIESIOGIAI makeStyles viduje — tas pats paternas, kaip Fluent
// pati naudoja savo "shared colors" (colorPaletteGold*) — vidinis, ne per temos token'us.
export const goldPalette = {
  50: '#fef9f2',
  100: '#faefd9',
  200: '#f3ddb0',
  300: '#e8c57c',
  400: '#d4a44a',
  500: '#a07639',
  600: '#855e28',
  700: '#68461a',
  800: '#4c300f',
  900: '#301b06',
};

// "Stone" — šilta neutrali skalė (ne Fluent numatytoji šalta pilka), naudojama
// puslapių sekcijų fonams/tamsiems blokams ten, kur reikia neutralaus, bet
// SĄMONINGAI parinkto (ne numatytojo) atspalvio — dera su medine/šiltos gamybos
// prekės ženklo nuotaika, papildo žalią, nekonkuruoja su ja kaip antra "spalva".
export const stonePalette = {
  50: '#fafaf9',
  100: '#f4f3f1',
  200: '#e8e6e1',
  300: '#d6d4cd',
  400: '#a8a6a0',
  500: '#6b6b68',
  600: '#55534f',
  700: '#3a3a38',
  800: '#242422',
  900: '#171716',
};

export const fititLightTheme = createLightTheme(fititBrandRamp);
export const fititDarkTheme = createDarkTheme(fititBrandRamp);
